export default __webpack_public_path__ + "static/media/woocommerce-settings-plugin.c5225c7a.gif";